"use strict";
export var IconSize = /* @__PURE__ */ ((IconSize2) => {
  IconSize2["Small"] = "small";
  IconSize2["Medium"] = "medium";
  IconSize2["Large"] = "large";
  return IconSize2;
})(IconSize || {});
